// NATIVE 
import * as React from 'react';

// INSTALLED 
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import DeleteIcon from '@mui/icons-material/Delete';
import Menu, { MenuProps } from '@mui/material/Menu';
import { styled, alpha  } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import TableContainer from '@mui/material/TableContainer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Card, Chip, Pagination, TablePagination } from '@mui/material';



// CUSTOM 
import { paddingCardsTables, timeToClosedToast } from '../../commons';
import MultipleSnackbars from '../MultipleSnackbars';
import { storeDetailCargos } from '../../store/cargos';
import { showNumberRowsTable } from '../../commons/utils/values';
import { CreateDialogCargo } from '../modals/cargos/CreateDialogCargo';
import { getEmployesByPagination, getEmployeStore, storeActiveEmploye, storeDesactiveEmploye, storeDetailEmployee } from '../../store/employee';
import { ModalSessionExpired } from '../generics/ModalSessionExpired';
import { SnackAlert } from '../SnackAlert';
import { closeSessionGlobal, hasPemissions } from '../../commons/utils';
import { AvatarTables } from '../AvatarTables';






const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.secondary.contrastText,
    fontSize: 15,
    fontWeight: 700
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontWeight: 500,
    color: '#2e263de6'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));






/**
 * TableEmpleados component is responsible for rendering a table of employees with various functionalities
 * such as viewing details, editing, deactivating, and restoring employees. It utilizes Redux for state
 * management and Material-UI for styling and UI components.
 *
 * @component
 *
 * @example
 * return (
 *   <TableEmpleados />
 * )
 *
 * @returns {JSX.Element} The rendered component.
 *
 * @remarks
 * This component fetches the employee data from the Redux store and displays it in a table format.
 * It also provides pagination and various actions that can be performed on each employee.
 *
 * @function
 * @name TableEmpleados
 *
 * @requires useDispatch - Redux hook to dispatch actions.
 * @requires useNavigate - React Router hook to navigate between routes.
 * @requires useSelector - Redux hook to access the state.
 * @requires React.useState - React hook to manage local state.
 * @requires React.useEffect - React hook to perform side effects.
 * @requires styled - Material-UI utility for styling components.
 * @requires Menu - Material-UI component for displaying a menu.
 * @requires MenuItem - Material-UI component for displaying a menu item.
 * @requires Button - Material-UI component for displaying a button.
 * @requires Table - Material-UI component for displaying a table.
 * @requires TableContainer - Material-UI component for containing a table.
 * @requires TableHead - Material-UI component for displaying the table header.
 * @requires TableBody - Material-UI component for displaying the table body.
 * @requires TableRow - Material-UI component for displaying a table row.
 * @requires TableCell - Material-UI component for displaying a table cell.
 * @requires TablePagination - Material-UI component for displaying table pagination.
 * @requires Card - Material-UI component for displaying a card.
 * @requires Paper - Material-UI component for displaying paper.
 * @requires Chip - Material-UI component for displaying a chip.
 * @requires Divider - Material-UI component for displaying a divider.
 * @requires Box - Material-UI component for displaying a box.
 * @requires Pagination - Material-UI component for displaying pagination.
 * @requires MultipleSnackbars - Custom component for displaying multiple snackbars.
 * @requires SnackAlert - Custom component for displaying a snack alert.
 * @requires ModalSessionExpired - Custom component for displaying a session expired modal.
 * @requires CreateDialogCargo - Custom component for displaying a create cargo dialog.
 * @requires DetailDialogCargo - Custom component for displaying a detail cargo dialog.
 * @requires EditDialogCargo - Custom component for displaying an edit cargo dialog.
 *
 * @param {Object} props - The props that are passed to the component.
 *
 * @todo Implement the editing functionality for employees.
 * @todo Add proper error handling and loading states.
 */
export const TableEmpleados = () => {


  // USE DISPATCH 
  const dispatch = useDispatch();


  // USE NAVIGATE 
  const navigate = useNavigate();


  // USE SELECTOR 
  const { employee_list }:any  = useSelector( (state:any) => state.employee );

  

  // USE STATE 
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openElem, setOpenElem] = React.useState(null);


  const [dataTableList, setDataTable] = React.useState([]);
  const [pagination, setPagination] = React.useState<any>({
      "page": 1,
      "take": 1,
      "itemCount": 1,
      "pageCount": 1,
      "hasPreviousPage": false,
      "hasNextPage": false
  });


  const [msgErrors, setMsgErrors] = React.useState([]);
  const [open_cargo, setOpenCargo]     = React.useState(false);
  const [buttons, setButtons] = React.useState(false);
  const [modalDetalleCargo, setModalDetalleCargo] = React.useState(false);
  const [modalEditarCargo, setModalEditar] = React.useState(false);


  const [page, setPage] = React.useState(0);
  const [pagePagination, setPagePagination] = React.useState(1);
  const [itemCountPagination, setItemCountPagination] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(showNumberRowsTable);


  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);


  const [canEdit, setCanEdit]     = React.useState<boolean>(false);
  const [canDelete, setCanDelete]     = React.useState<boolean>(false);
  const [canRestore, setCanRestore]     = React.useState<boolean>(false);


  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });




  const StyledMenu = styled((props: MenuProps) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color:
        theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '7px 0',
      },
      '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        '&:active': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  }));
  
  
  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center'
  }));




  // CONST VALUES 
  const open = Boolean(anchorEl);



 
  // USE EFFECT 
  React.useEffect(() => {
      
    if ( employee_list.data && employee_list.data.length > 0 ) {
      
      setDataTable(employee_list.data);
      setPagination({
        "page": employee_list.meta.page,
        "take": employee_list.meta.take,
        "itemCount": employee_list.meta.itemCount,
        "pageCount": employee_list.meta.pageCount,
        "hasPreviousPage": employee_list.meta.hasPreviousPage,
        "hasNextPage": employee_list.meta.hasNextPage
      });
      setItemCountPagination(employee_list.meta.pageCount);
      
    }
    

  }, [employee_list]);


  React.useEffect(() => {
    // HERE LOAD THE DATA FOR DATATABLE
    getDataEmployes();
  }, []);


  React.useEffect(() => {
    checkEdit()
  }, []);

  React.useEffect(() => {
      checkCanDelete()
  }, []);

  React.useEffect(() => {
    checkRestore()
  }, []);




  // CONST FUNCTIONS 
  const handleClick = (elem:any) => (event:any) => {
    setAnchorEl(event.currentTarget);
    setOpenElem(elem);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenElem(null);
  };



  const getDataEmployes = async() => {
    

      // modulo.thumano                             nombre modulo     sub modulo    permission
      const havePermissions = await hasPemissions('modulo.thumano', 'modulo.empleados', 'view');
  
  
      if( !havePermissions ){
 
 
        await validateLsPermissions('No tienes pemisos para (Listar) empleados.');

        return false;
 
         
      }

    
      const response = await dispatch( getEmployeStore() );

      await validateResponse(response, ' (Listar Empleado) ');
  
  
  }
  
 

  const openDialogDetalle = async(employeeId:string) => {
      


        setAnchorEl(null);
        setOpenElem(null);
        setButtons(false);



        // modulo.thumano                             nombre modulo     sub modulo    permission
        const havePermissions = await hasPemissions('modulo.thumano', 'modulo.empleados', 'view');
  
  
        if( !havePermissions ){
  
  
          await validateLsPermissions('No tienes pemisos para (Ver) empleado.');
  
      
            return false;
  
          
        }

       
        const response = await dispatch( storeDetailEmployee(employeeId) );


        const result = await validateResponse(response, ' (Ver empleado) ');

        if (!result) {
           return false;
        }

       
        navigate("/talento-humano/empleado/detalle");

       
  }

  const openDialogEditar = async(areaId:string) => {
      
      // LA EDICION DE USUARIO ESTA PENDIENTE 
    // await dispatch( storeDetailAreas(areaId) );
   
    setAnchorEl(null);
    setOpenElem(null);
    setButtons(false);


    // modulo.thumano                             nombre modulo     sub modulo    permission
    const havePermissions = await hasPemissions('modulo.thumano', 'modulo.empleados', 'view');
  
  
    if( !havePermissions ){


      await validateLsPermissions('No tienes pemisos para (Ver) empleado.');

  
        return false;

      
    }


    // const response = await dispatch( storeDetailCargos(areaId) );


    // const result = await validateResponse(response, ' (Ver empleado) ');

    // if (!result) {
    //     return false;
    // }

    // setModalEditar(true);

  }


  const desactiveEmploye = async(employeId:string) => {


      setAnchorEl(null);
      setOpenElem(null);
      setButtons(false);


      // modulo.thumano                             nombre modulo     sub modulo    permission
      const havePermissions = await hasPemissions('modulo.thumano', 'modulo.empleados', 'delete');
    
    
      if( !havePermissions ){


        await validateLsPermissions('No tienes pemisos para (Desactivar) empleado.');

    
          return false;

        
      }

      
      const response = await dispatch( storeDesactiveEmploye(employeId) );


      await validateResponse(response, ' (Desactivar) empleado ');

      


  }


  const restoreEmploye = async(employeId:string) => {


    setAnchorEl(null);
    setOpenElem(null);
    setButtons(false);


    // modulo.thumano                             nombre modulo     sub modulo    permission
    const havePermissions = await hasPemissions('modulo.thumano', 'modulo.empleados', 'restore');
    
    
    if( !havePermissions ){


      await validateLsPermissions('No tienes pemisos para (Restaurar) empleado.');

  
        return false;

      
    }


    const response = await dispatch( storeActiveEmploye(employeId) );


    await validateResponse(response, ' (Restaurar) empleado ');
    

  }

  

  const handleCloseModalCrearCargo = () => {
        setOpenCargo(false)
  }

  const handleCloseModalDetailCargo = () => {
       setModalDetalleCargo(false);
  }

  
  const handleCloseModalEditarCargo = () => {
       setModalEditar(false);
  }

 


 


  const handleChangePage = (event: unknown, newPage: number) => {
  
    setPage(newPage);

  };


  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
  
        setRowsPerPage(+event.target.value);
  
        setPage(0);
  
  };

  const changePaginationPage = async(event: React.ChangeEvent<unknown>, value: number) => {
            
          setPagePagination(value)
      
          const response =  await dispatch( getEmployesByPagination(value) );


          await validateResponse(response, ' (Listar) empleado ');
          
          
      
  };



  const validateLsPermissions = async(message:string) => {
  
        const errors:any = {
          msg: message,
          status: 'error'
        };
      
        await setMsgSnack(errors);
        await setAlertSnack(true);
      
      
      }
  
  
      const validateResponse = async(response:any, textActionConcat: string) => {
          
          
            if (  response.code == 401  ) {
              await localStorage.removeItem('lastSelectedQypht');
              await closeSessionGlobal();
              setModalSessionExpired(true);
              return false;
            }
    
          
            // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
            if (!response.ok && response.code == 403 ) { 
    
            
              const errors:any = {
                msg: response.errors[0]+' '+textActionConcat,
                status: 'error'
              };
            
              await setMsgSnack(errors);
              await setAlertSnack(true);
    
            
              return false;
              
            }
    
            
            // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
            if (!response.ok && response.code == 400 ) { 
    
              const errors:any = [];
    
              response.errors.forEach( (element:any) => {
                  
                  errors.push({
                    type: 'error',
                    text: element
                  })
              });
    
                
              setMessagesAlerts(errors);
              return false;
    
            }
    
            return true;
          
      }
  
  
  
    const checkEdit = async() => {
                
        
      const hasPermissionsEdit = await hasPemissions('modulo.thumano', 'modulo.empleados', 'edit');
    
      if ( hasPermissionsEdit ) {
            setCanEdit(true);
      }

    }
    
    
    const checkCanDelete = async() => {
        
        
        const havePermissions = await hasPemissions('modulo.thumano', 'modulo.empleados', 'delete');
        
        if ( havePermissions ) {
              setCanDelete(true);
        }
  
    }
    
    
    const checkRestore = async() => {
        
        const havePermissions = await hasPemissions('modulo.thumano', 'modulo.empleados', 'restore');
          
        if ( havePermissions ) {
              setCanRestore(true);
        }
  
    }

  
  return (

    <>

        <ModalSessionExpired  open={modalSessionExpired}  />
        <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
        <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>

      

        <CreateDialogCargo open={open_cargo} handleCloseModalCrearCargo={handleCloseModalCrearCargo} buttons={buttons}/>
        {/* <DetailDialogCargo open={modalDetalleCargo} handleCloseModalDetailCargo={handleCloseModalDetailCargo} /> */}
        {/* <EditDialogCargo  open={modalEditarCargo} handleCloseModalEditarCargo={handleCloseModalEditarCargo} /> */}
       

       {
            
            dataTableList.length > 0
                
              ?
              <>
              <Card
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  p: 3,
                  borderRadius: 2,
                  boxShadow: 3,
                  bgcolor: 'background.paper',
                  marginTop: paddingCardsTables
                }}
              >
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell >Foto</StyledTableCell>
                      <StyledTableCell >N° Documento</StyledTableCell>
                      {/* <StyledTableCell >Compañia</StyledTableCell> */}
                      <StyledTableCell >Cargo</StyledTableCell>
                      <StyledTableCell >Estado</StyledTableCell>
                      <StyledTableCell >Acciones</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                    dataTableList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((employe:any, index:any) => (
                      <StyledTableRow key={index+1}  >
                        <StyledTableCell component="th" scope="row" onClick={ () => openDialogDetalle(employe.id) }>
                         <AvatarTables urlImage={employe.employee_avatar} typeImage='image-employee' />
                        </StyledTableCell>
                        <StyledTableCell >
                        {employe.document_number} 
                        </StyledTableCell>
                        {/* <StyledTableCell >
                          {employe.company} 
                        </StyledTableCell> */}
                        <StyledTableCell >
                          {employe.position.name} 
                        </StyledTableCell>
                        <StyledTableCell >
                          {
                            employe.status ? <Chip size='small' label="Activo" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} /> : <Chip size='small' label="Inactivo" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }} />
                          }
                        </StyledTableCell>
                        <StyledTableCell  >
                              
                        
                        {
                        
                            <div> 
                                <Button
                                  id={`demo-customized-button-${index+1}`}
                                  aria-controls={open ? `demo-customized-menu-${index+1}` : undefined}
                                  aria-haspopup="true"
                                  aria-expanded={open ? 'true' : undefined}
                                  variant="text"
                                  disableElevation
                                  onClick={handleClick(employe)}
                                  endIcon={<KeyboardArrowDownIcon />}
                                >
                                  Acciones
                                </Button>
                                <StyledMenu
                                  id={`demo-customized-menu-${index+1}`}
                                  MenuListProps={{
                                    'aria-labelledby': `demo-customized-button-${index+1}`,
                                  }}
                                  anchorEl={anchorEl}
                                  open={openElem === employe}
                                  onClose={handleClose}
                                >
                                  
                                  {
                                    (employe.status) 
                                      ? <div>
                                        <MenuItem onClick={ () => openDialogDetalle(employe.id) }  disableRipple>
                                        <VisibilityIcon />
                                          Detalle 
                                        </MenuItem>
                                        {
                                           canEdit &&
                                             <>
                                                <Divider sx={{ my: 0.5 }} />
                                                <MenuItem onClick={ () => openDialogEditar(employe.id) }  disableRipple>
                                                 <EditIcon />
                                                   Editar
                                                </MenuItem>
                                             </>
                                        }
                                      </div>
                                      :
                                      ''
                                  }
                                  
                                  {
                                    (employe.status) 
                                    ?
                                      <div>
                                         {
                                           canDelete && 
                                                <>
                                                   <Divider sx={{ my: 0.5 }} />
                                                   <MenuItem onClick={ () => desactiveEmploye(employe.id) } disableRipple>
                                                     <DeleteIcon />
                                                     Desactivar
                                                    </MenuItem>
                                                </>
                                         }
                                      </div>
                                    :
                                    <div>
                                         {
                                            canRestore && 
                                               <>
                                                  <Divider sx={{ my: 0.5 }} />
                                                  <MenuItem onClick={ () => restoreEmploye(employe.id) } disableRipple>
                                                    <DeleteIcon />
                                                    Activar
                                                  </MenuItem>
                                               </>
                                         }
                                    </div>
                                    
                                  }
                                  </StyledMenu>
                              </div>
                    
                        }
        
        
        
        
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              </Card>
              <TablePagination
              rowsPerPageOptions={[5, 10]}
              labelRowsPerPage={'Filas por pagina'}
              labelDisplayedRows={({ from, to, count }) => ` ${from}-${to} de  ${count} `}
              component="div"
              count={pagination.itemCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={ handleChangePage }
              onRowsPerPageChange={ handleChangeRowsPerPage }
            />
  
            <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 2,
                    marginBottom: 2
                  }}
                >
                <Pagination sx={{ justifyContent: 'center' }} color="primary" count={itemCountPagination} page={pagePagination} onChange={ changePaginationPage} showFirstButton showLastButton />
             </Box>
             </>
              :
              <Div>{"No hay empleados creados..."}</Div>
       }


       
       
    </>
    
  );
}



